import { actions as newsActions } from '../reports'
import { constants as authConstants } from '../auth'
import { PENDING, SUCCESS, FAIL } from '../../reduxPromise'

class FormViewsMiddleware {
}

export default new FormViewsMiddleware()
